import {
    Box,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"
import React from "react"
import type { PropsWithChildren } from "react"

export default function FilterTag({ children }: PropsWithChildren) {
    const styles = useStyleProps()

    return <Box style={styles.container}>{children}</Box>
}

function useStyleProps() {
    const colors = useColors()

    return componentStyles({
        container: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.75rem",
            color: colors.contentInversePrimary,
            width: "1.25rem",
            height: "1.25rem",
            backgroundColor: colors.backgroundInversePrimary,
            borderRadius: "50%",
            marginLeft: "8px",
        },
    })
}
